import { useState } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, Box, TextField, Card } from "@mui/material";
import { form_add, buttonStyle } from "../style/style";
import { NotificationManager } from "react-notifications";
import { FormControl } from "@mui/material";
import { postobj, updateobj } from "../apicall/apicall";
import { useNavigate } from "react-router-dom";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
export default function PasswordChange() {
  const [open, setopen] = useState(true);
  const [pwd2, setpwd2] = useState();
  const [newVal] = useState({
    id: sessionStorage.getItem("id"),
    password_changed: true,
  });
  const [password, setpassword] = useState({
    old_password: "",
    new_password: "",
  });
  const handlepassword = (e) => {
    const { name, value } = e.target;
    setpassword({
      ...password,
      [name]: value,
    });
  };
  const updateCustomerInfo = () => {
    const url =
      process.env.REACT_APP_ZEWA_URL + "user/update/" + newVal["id"] + "/";
    updateobj(url, newVal).then(function (res) {
      //console.log(res);
      const url = process.env.REACT_APP_ZEWA_URL + "user/reset-password/";
      postobj(url, password).then(function (r) {
        if (r["Message"] === "Password changed successfully") {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Password Changed.", "Success", 2000);
          sessionStorage.setItem("token", "");
          history({ pathname: "/" });
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Incorrect password", "Failed", 2000);
          setopen(false);
        }
      });

      //setrefresh(!refreshed);
    });
  };
  const history = useNavigate();
  const handlePasswordChange = () => {
    if (pwd2 === password.new_password) {
      updateCustomerInfo();
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("Password did not match", "Failed", 2000);
      setopen(false);
    }
  };
  const reset = () => {
    setpassword({
      old_password: "",
      new_password: "",
    });
    setpwd2("");
    setopen(false);
    history({ pathname: "/" });
  };
  return (
    <div>
      <Card sx={{ margin: "30px" }}>
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <TextField
              name="old_password"
              sx={form_add}
              type="password"
              label="Enter Old Password"
              variant="standard"
              value={password.old_password}
              onChange={handlepassword}
            />
            <TextField
              name="new_password"
              sx={form_add}
              type="password"
              label="Enter New Password"
              variant="standard"
              value={password.new_password}
              onChange={handlepassword}
            />
            <TextField
              name="New Password"
              sx={form_add}
              type="password"
              label="Re-enter New Password"
              variant="standard"
              value={pwd2}
              onChange={(e) => {
                setpwd2(e.target.value);
              }}
            />
            <Box m={1} sx={{ marginLeft: "-10px" }}>
              <Button
                color="primary"
                variant="contained"
                className="form__custom-button"
                sx={buttonStyle}
                type="submit"
                onClick={handlePasswordChange}
              >
                Change
              </Button>
              <Button
                color="error"
                variant="contained"
                className="form__custom-button"
                sx={buttonStyle}
                type="submit"
                onClick={reset}
              >
                Cancel
              </Button>
            </Box>
          </FormControl>
        </DialogContent>
        <DialogActions></DialogActions>
      </Card>
      <NotificationContainer />
    </div>
  );
}
